import { createContext } from 'react';

export const ModalOpenContext = createContext(true);
